import React, { Component } from 'react';
import { Input, Button, Card, Form, Select, Icon, Alert, Popconfirm } from 'antd';
import { BaseRequest } from 'models/request/BaseRequest';
import { ProcedureRequest } from 'models/request/ProcedureRequest';
import { executeProcedure } from 'services/CeberusApiService';
import { PushNotification } from 'utils/PushNotification';

const PARAMS_BY_OPTION: Record<string, { description: string; params: string[] }> = {
  stp_template_sms: {
    description: 'Update SMS Template',
    params: ['Owner', 'Template'],
  },
  stp_enable_or_disable_bot: {
    description: 'Enable or Disable Bot',
    params: ['IsActive', 'ApplicationIdentity'],
  },
  stp_Update_PaymentAccount: {
    description: 'Update Payment Account',
    params: ['PaymentAccount', 'ApplicationIdentity'],
  },
  stp_Get_User_Permission: {
    description: 'Get User Permission',
    params: ['Email', 'BotId'],
  },
  stp_Verify_Organization: {
    description: 'Verify Organization',
    params: ['Tenant'],
  },
  stp_Delete_Organization: {
    description: 'Delete Organization',
    params: ['Tenant'],
  },
  stp_block_domain_desk: {
    description: 'Block Domain Desk',
    params: ['Owner', 'Caller', 'Name', 'Value'],
  },
};

export class Procedure extends Component<BaseRequest> {
  state = {
    dropdownValue: '',
    params: {} as Record<string, string>,
    submitting: false,
  };

  handleDropdownChange = (value: string) => {
    const paramNames = PARAMS_BY_OPTION[value]?.params || [];
    const params: Record<string, string> = {};
    paramNames.forEach(name => (params[name] = ''));
    this.setState({ dropdownValue: value, params });
  };

  handleInputChange = (paramName: string, value: string) => {
    this.setState((prevState: any) => ({
      params: { ...prevState.params, [paramName]: value },
    }));
  };

  isFormValid = () => {
    const { dropdownValue, params } = this.state;
    if (!dropdownValue) return false;
    const paramNames = PARAMS_BY_OPTION[dropdownValue]?.params || [];
    return paramNames.every(name => !!params[name]);
  };

  handleSubmit = async () => {
    if (!this.isFormValid()) return;
    this.setState({ submitting: true });
    const request = new ProcedureRequest();
    request.ProcedureName = this.state.dropdownValue;
    request.ProcedureParameters = this.state.params;
    try {
      const response = await executeProcedure(request);
      PushNotification.success(response.data || 'Procedure executed successfully');
    } catch (error) {
      PushNotification.error('Error executing procedure. Please contact the team.');
    } finally {
      this.setState({ submitting: false });
    }
  };

  render() {
    const { dropdownValue, params, submitting } = this.state;
    const paramNames = PARAMS_BY_OPTION[dropdownValue]?.params || [];

    return (
      <div className="flex flex-wrap">
        <div className="tc w-100">
          <h1>
            <Icon type="bars" className="mr3" />
            Select a functionality to execute
          </h1>
        </div>
        <div className="mt w-100">
          <Card title="Parameters" className="w-100">
            <Form layout="vertical">
              <Form.Item label="Select the functionality to execute:" required>
                <Select
                  placeholder="Select an option"
                  value={dropdownValue}
                  onChange={this.handleDropdownChange}
                  style={{ width: 300 }}
                >
                  {Object.entries(PARAMS_BY_OPTION).map(([optionKey, optionValue]) => (
                    <Select.Option key={optionKey} value={optionKey}>
                      {optionValue.description}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item>
                <Alert
                  message="Careful!"
                  description="This action will execute a storage procedure on database. All the parameters are required."
                  type="warning"
                  showIcon
                />
              </Form.Item>
              {paramNames.map(paramName => (
                <Form.Item
                  key={paramName}
                  label={paramName}
                  required
                >
                  <Input
                    placeholder={`Type ${paramName.toLowerCase()}`}
                    value={params[paramName]}
                    onChange={e => this.handleInputChange(paramName, e.target.value)}
                    style={{ width: 300 }}
                    required
                  />
                </Form.Item>
              ))}
              <Popconfirm
                key="confirm"
                title="This action will execute a storage procedure on database. Are you sure you want to proceed?"
                onConfirm={this.handleSubmit}
                okText="Yes"
                cancelText="No"
              >
                <Button
                type="primary"
                disabled={!this.isFormValid() || submitting}
                loading={submitting}
              >
                Execute
              </Button>  
              </Popconfirm>
            </Form>
          </Card>
        </div>
      </div>
    );
  }
}